/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$getPrototypeOf = _interopDefault(require('babel-runtime/core-js/object/get-prototype-of'));
var _classCallCheck = _interopDefault(require('babel-runtime/helpers/classCallCheck'));
var _possibleConstructorReturn = _interopDefault(require('babel-runtime/helpers/possibleConstructorReturn'));
var _inherits = _interopDefault(require('babel-runtime/helpers/inherits'));
var minilo = require('./minilo');

var AssertionError = function (_Error) {
  _inherits(AssertionError, _Error);

  function AssertionError(message) {
    _classCallCheck(this, AssertionError);

    var _this = _possibleConstructorReturn(this, (AssertionError.__proto__ || _Object$getPrototypeOf(AssertionError)).call(this, message));

    _this.name = _this.constructor.name;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(_this, _this.constructor);
    } else {
      _this.stack = new Error(message).stack;
    }
    return _this;
  }

  return AssertionError;
}(Error);

/**
 * @param {*} value
 * @param {string} message
 * @throws AssertionError
 */
function assert(value, message) {
  if (!value) {
    throw new AssertionError(message || 'Assertion failed');
  }
}

/**
 * Alias of `assert` function.
 * @param value
 * @param message
 */
function ok(value, message) {
  return assert(value, message);
}

/**
 * @param {*} value
 * @throws {AssertionError}
 */
function numeric(value) {
  assert(minilo.isNumeric(value), 'value is a number');
}

/**
 * @param {*} value
 * @param {Function} Ctor
 * @throws {AssertionError}
 */
function instanceOf(value, Ctor) {
  assert(value instanceof Ctor, 'value is an instance of ' + Ctor.name);
}

function hasOlObject(vm) {
  assert(vm.$olObject, 'component has "$olObject" property');
}

/**
 * @param {Object} vm
 * @return {void}
 * @throws {AssertionError}
 */
function hasMap(vm) {
  assert(vm.$map, 'component has "$map" property');
}

/**
 * @param {Object} vm
 * @return {void}
 * @throws {AssertionError}
 */
function hasView(vm) {
  assert(vm.$view, 'component has "$view" property');
}

/**
 * @param {Object} vm
 * @return {void}
 * @throws {AssertionError}
 */
function hasGeolocation(vm) {
  assert(vm.$geolocation, 'component has "$geolocation" property');
}

/**
 * @param {Object} vm
 * @return {void}
 * @throws {AssertionError}
 */
function hasFeature(vm) {
  assert(vm.$feature, 'component has "$feature" property');
}

/**
 * @param {Object} vm
 * @return {void}
 * @throws {AssertionError}
 */
function hasLayer(vm) {
  assert(vm.$layer, 'component has "$layer" property');
}

/**
 * @param {Object} vm
 * @return {void}
 * @throws {AssertionError}
 */
function hasSource(vm) {
  assert(vm.$source, 'component has "$source" property');
}

/**
 * @param {Object} vm
 * @return {void}
 * @throws {AssertionError}
 */
function hasGeometry(vm) {
  assert(vm.$geometry, 'component has "$geometry" property');
}

/**
 * @param {Object} vm
 * @return {void}
 * @throws {AssertionError}
 */
function hasInteraction(vm) {
  assert(vm.$interaction, 'component has "$interaction" property');
}

/**
 * @param {Object} vm
 * @return {void}
 * @throws {AssertionError}
 */
function hasStyle(vm) {
  assert(vm.$style, 'component has "$style" property');
}

/**
 * @param {Object} vm
 * @return {void}
 * @throws {AssertionError}
 */
function hasOverlay(vm) {
  assert(vm.$overlay, 'component has "$overlay" property');
}

function hasGraticule(vm) {
  assert(vm.$graticule, 'component has "$graticule" property');
}

exports.AssertionError = AssertionError;
exports.assert = assert;
exports.ok = ok;
exports.numeric = numeric;
exports.instanceOf = instanceOf;
exports.hasOlObject = hasOlObject;
exports.hasMap = hasMap;
exports.hasView = hasView;
exports.hasGeolocation = hasGeolocation;
exports.hasFeature = hasFeature;
exports.hasLayer = hasLayer;
exports.hasSource = hasSource;
exports.hasGeometry = hasGeometry;
exports.hasInteraction = hasInteraction;
exports.hasStyle = hasStyle;
exports.hasOverlay = hasOverlay;
exports.hasGraticule = hasGraticule;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/util/assert.js
// module id = 24
// module chunks = 1